import { Area } from './area.model'
import { CLIENT_ID } from './client.model'
import { ENTRANCE_ID } from './entrance.model'
import { EVENT_ID } from './event.model'
import { StationType } from '../../app/shared/app.enums'

export type STATION_ID = string | number

export interface BlockedHour {
  start: string
  end: string
}

export interface DateRange {
  from: string
  to: string
}

export interface RestrictionRule {
  enabled: boolean
  comment?: string
  days?: number[]
  hours?: BlockedHour[]
  date_range?: DateRange
  dates?: string[]
  bypass_role_ids?: number[]
}

export interface EntryRestrictions {
  restricted_now: boolean
  schedule_active: boolean
  bypass_disabled: boolean
  bypass_client_role_ids?: number[]
  rules?: RestrictionRule[]
}

/* Which fields the Gaterix kiosk collects on a VISITOR_REGISTRATION station.
   Mobile is always true — the pass is delivered by SMS and matched by phone. */
export interface RegistrationFields {
  first_name: boolean
  last_name: boolean
  country_code: boolean
  mobile: boolean
  id_number: boolean
}

export class Station {
  id: STATION_ID
  client_id: number
  event_id: number
  entrance_id: number
  name: string
  icon?: string
  ip: string
  areas?: Array<number | Area> = []
  type? = StationType.front_camera
  keep_open: boolean
  last_sync: string
  recentMeanScanRate: number = NaN
  totalTickets: number = NaN
  totalScanned: number = NaN
  peakPoint: number = NaN
  batteryLevel = NaN
  version: string
  extra?: string
  entry_restrictions?: EntryRestrictions | null
}

export class CreateStationInput {
  client_id: CLIENT_ID = NaN
  event_id: EVENT_ID = NaN
  entrance_id: ENTRANCE_ID = NaN
  name: string = ''
  areas?: Array<number> = []
  type? = StationType.front_camera
  keep_open: boolean = false
  extra?: string = ''
}

export class UpdateStationInput {
  id: STATION_ID = NaN
  event_id?: EVENT_ID = NaN
  entrance_id?: ENTRANCE_ID = NaN
  name?: string = ''
  areas?: Array<number> = []
  type? = StationType.front_camera
  keep_open?: boolean = false
  extra?: string = ''
}

export class ResponseStation {
  id: STATION_ID = NaN
  event_id?: EVENT_ID = NaN
  entrance_id?: ENTRANCE_ID = NaN
  name?: string = ''
  areas?: Array<number> = []
  type? = StationType.front_camera
  icon: string = ''
  keep_open?: boolean = false
  extra?: string = ''
}
